import pic_01 from './Assets/pic_01.webp';
import pic_02 from './Assets/pic_02.webp';
import pic_03 from './Assets/pic_03.webp';
import pic_04 from './Assets/pic_04.webp';
import pic_05 from './Assets/pic_05.webp';
import pic_06 from './Assets/pic_06.webp';
import pic_07 from './Assets/pic_07.webp';
import pic_08 from './Assets/pic_08.webp';
import pic_09 from './Assets/pic_09.webp';
import pic_10 from './Assets/pic_10.webp';
import pic_11 from './Assets/pic_11.webp';
import pic_12 from './Assets/pic_12.webp';
import pic_13 from './Assets/pic_13.webp';
import ambassadorImage from './Assets/synapse.png'

export const ambassador = {
  name: 'Synapse',
  position: 'right',
  description: <>
    <p>
      I'm a big gamer myself and i've always liked to watch streams. My hobby was watching League of legends stream highlights on Reddit. When <a href="https://twitch.tv/" target="_blank">Twitch.tv</a> featured clip pages for every streamer, i've became very efficient at finding the best clips and started making highlight compilations on youtube. I've created the new style of high action packed best moments from my favorite game with a bit of memes and IRL stuff. After a huge success, many highlight channels were created by other people using my style, not only for League, but for many other games from <a href="https://twitch.tv/" target="_blank">Twitch.tv</a>.
    </p>
  </>,
  image: ambassadorImage,
  socialLinks: {
    youtube: 'https://www.youtube.com/@Synapse1',
    twitch: 'https://www.twitch.tv/synapsetv',
    twitter: 'https://x.com/Synapse144',
  },
};

export const EpochInfo = {
  title: 'TWITCH ART',
  period: '2011 - present',
  description: <>
    <p>
      Twitch Art represents a unique movement in game blogging, marking one of the earliest evolutions of live streaming platforms. This trend turned gamers’ dreams into reality, allowing them not only to earn money while playing games but also to gain popularity and recognition within their communities. What makes Twitch Art fascinating is its blend of vibrant digital activity with the physical body's stillness, creating a dynamic yet passive experience for both streamers and viewers.
    </p>
  </>,
};

export const events = [
  {
    year: '2007',
    title: 'Justin’s Life',
    content: (
      <>
        <p>
          It all began in 2007 with Justin.tv, a groundbreaking 24/7 live streaming platform that invited viewers into the world of its creator, Justin Kan. People could tune in at any time to see what he was up to — whether he was sleeping, eating, chatting, or even taking a bathroom break, all captured from a camera strapped to his head. Eventually, Justin decided to step back from his streams, opening the door for other creators to take the stage on the platform.
        </p>
      </>
    ),
    img: pic_01,
    blurhash: '|68p[b9F0g~AIpJD#ktREL4.S$s:%2%1IUbb$*ofD+-oob9axas-Nxnis.IpaxxaIVWY%KniI:bHocRl$%xZIqjFt5NHjYxuV@j[t7IVt7t5RlWCRkaxS4jcxsS4Rj%0R+jYozM{M{xuRkWYxYofWSafjvx[soIUNws.oe',
    picName: 'pic_01',
  },
  {
    year: '2011',
    title: 'Twitch Gameplay',
    content: (
      <>
        <p>
          In 2011, the company shifted its focus to gameplay, recognizing the growing interest in watching others play games. This led Justin to create the TwitchTV platform, inspired by the term "twitch gameplay," which describes fast-paced moments in video games that challenge a player's reaction time.
        </p>
      </>
    ),
    img: pic_02,
    blurhash: '|FD8%p9t5W=|V@~BEMSi^PsmNHRj-UIps.oeE2xGoMIot6s:I:WBjZWVWVNHxZxYofNHoJs:WVofRks:s.WBogR*ofs.WVxaR*NHs-axt7WUayWCWVWWjZs.WWR*oKWBbHs.jZWXR*WVayays.ayNHfks.ofayj@ofWVj]',
    picName: 'pic_02',
  },
  {
    year: '2011-2023',
    title: 'The Fastest Mario',
    content: (
      <>
        <p>
          Super Mario 64 holds a special place in the world of Twitch speedrunning, consistently captivating fans with its thrilling attempts to beat record times. In 2023, renowned speedrunner Suigi made headlines by achieving a remarkable new world record, completing the game in just 6 minutes and 58.35 seconds — using only one star.
        </p>
      </>
    ),
    img: pic_03,
    blurhash: '|49GdRr;011Q03$d~VwIIVEgxZsoIpj@%1oeIpR+00XT^+vy^*%f9FNyoz=xIqIp%1%1RjNH%2jFlAwHn3yDD*9a-;WAjE%1NH%0xZ9aR.xaoHxtH?kXx]R5-oS$9G%L-o0gxaxZfhxuV@niX9Rj-;9aM{?aaxV@xuIpIW',
    picName: 'pic_03',
  },
  {
    year: '2015',
    title: 'TwitchCon',
    content: (
      <>
        <p>
          Streaming culture took shape at the first TwitchCon, held in September 2015 at the Moscone Center in San Francisco. This event brought together streamers, game developers, and platform creators, allowing them to exchange insights and connect with the broader Twitch community through live broadcasts. Since then, TwitchCon has been an annual highlight, except for a pause in 2020 due to the COVID-19 pandemic. The conference made a triumphant return in 2022, expanding its reach to both Europe and North America.
        </p>
      </>
    ),
    img: pic_04,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_04',
  },
  {
    year: '2017',
    title: 'Record-Breaking Crowd',
    content: (
      <>
        <p>
          The platform set a major milestone when 436,000 viewers tuned in live to watch Bungie and Activision’s Destiny 2 premiere. That record held strong for a long time, reinforcing Twitch’s dominance as the leading streaming platform in the U.S. since 2017.
        </p>
      </>
    ),
    img: pic_05,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_05',
  },
  {
    year: '2017',
    title: 'Expanded Features',
    content: (
      <>
        <p>
          At its core, live streaming is all about connection. In 2017, Twitch took viewer interaction to the next level by introducing extensions. Now, you can do more than just chat with your favorite streamer —  you can actually play games alongside them! With over 700 extensions available, streamers can customize their experience with features like voting, competitions, and additional stats, choosing the tools that best fit their style.
        </p>
      </>
    ),
    img: pic_06,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_06',
  },
  {
    year: '2018',
    title: 'Ninja vs. Drake',
    content: (
      <>
        <p>
          Want to know the secret to jumping from 70,000 to 630,000 viewers in a single stream? Just play Fortnite with a famous rapper! When popular streamer Ninja teamed up with Drake, it sent social media into a frenzy. That epic night created a ton of memes that are now part of gaming and blogging history. Plus, Fortnite rode the wave of that hype, dropping some awesome collabs like NFL Team Skins and the Thanos/Avengers collection.
        </p>
      </>
    ),
    img: pic_07,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_07',
  },
  {
    year: '2018',
    title: 'Record Collector',
    content: (
      <>
        <p>
          Fortnite is the king of Twitch, pulling in about 650,000 viewers at peak times. That’s a crowd as big, or even bigger, than some major news channels like MSNBC, CNN, or ESPN. The superstar streamer Ninja leads the way, but it was David “TheGrefg” Martínez who really stole the show when he revealed a new skin — his stream hit a jaw-dropping 2 million viewers.
        </p>
      </>
    ),
    img: pic_08,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_08',
  },
  {
    year: '2019',
    title: 'Just Chatting',
    content: (
      <>
        <p>
          In 2019, Twitch recognized a shift in viewer interests beyond gaming, leading to the creation of Just Chatting — a space for streamers to engage with their audience even when not playing. This new format has attracted a wealth of paid subscribers, as genuine conversations foster a strong sense of community. A notable example is XQC (a.k.a. Félix Lengyel), known for his vibrant and entertaining streams. While he began with gaming, his transition to chatting allowed him to connect more deeply with fans, capturing their hearts and support.
        </p>
      </>
    ),
    img: pic_09,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_09',
  },
  {
    year: '2020',
    title: 'COVID Boost',
    content: (
      <>
        <p>
          The pandemic shook things up, and Twitch really took off. With everyone stuck at home, watching streams became the go-to way to pass the time, and watch hours skyrocketed by 23%.
        </p>
      </>
    ),
    img: pic_10,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_10',
  },
  {
    year: '2020',
    title: 'Disguised Toast',
    content: (
      <>
        <p>
          Disguised Toast was one of the early streamers to dive into Among Us when the game exploded in popularity in September 2020. During this time, Twitch saw an incredible rise in viewership as this once-obscure game captivated millions, racking up around 147.1 million watch hours each month. Disguised Toast made the most of the moment, and to this day, he remains a well-watched and influential creator.
        </p>
      </>
    ),
    img: pic_11,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_11',
  },
  {
    year: '2020',
    title: 'Kappa Emote',
    content: (
      <>
        <p>
          Before jumping into a Twitch chat, it’s a good idea to know the Kappa emote. Kappa is Twitch’s universal symbol for sarcasm, irony, or playful trolling. Whether it’s slipped in at the end of a sentence or spammed on its own, Kappa is a go-to for signaling you’re not taking things too seriously. Fun fact: the face behind the emote belongs to a former Justin.tv engineer who helped set up the site’s chat system.
        </p>
      </>
    ),
    img: pic_12,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_12',
  },
  {
    year: '2023',
    title: 'The Endless Story',
    content: (
      <>
        <p>
          Streamers have always pushed the limits on how long they can stay live. From week-long Call of Duty marathons to non-stop charity streams, new records are constantly being set on Twitch. Each time someone breaks a record, the challenge gets tougher for the next person. By January 2023, the longest Twitch stream hit a mind-blowing 15,320 hours — 638 days straight — set by streamer GPHustla. His run only ended because Twitch banned his channel, but he had plans to hit 1,000 days. On his 365th day, he proudly tweeted: “I’m the first person in history to spend a whole year live, online, every single minute.”
        </p>
      </>
    ),
    img: pic_13,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_13',
  },
];